import AdaptiveImage from "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "809a9ffd4ca7324d598476e42e95cd7b.jpg","uri@2x": __webpack_public_path__ + "9ba3730f35b023f45d612d695b49f462.jpg","uri@3x": __webpack_public_path__ + "4b8f7131d5aae7448a4cc22ceae6d67c.jpg",
    width: 1024,
    height: 550
});